/**
 * Vue Router
 *
 * @library
 *
 * https://router.vuejs.org/en/
 */

import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'
import store from '@/store'

import paths from './paths'

const DEFAULT_ROUTE = '/list'

function route (path, view, name) {
  return {
    name: name || view,
    path,
    component: (resolve) => import(
      `@/views/${view}.vue`
    ).then(resolve)
  }
}

Vue.use(Router)

// Create a new router
export const router = new Router({
  mode: 'history',
  routes: paths.map(path => route(path.path, path.view, path.name)).concat([
    { path: '*', redirect: DEFAULT_ROUTE }
  ]),
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      return { selector: to.hash }
    }
    return { x: 0, y: 0 }
  }
})

const isAuth = () => store.getters['auth/isAuthenticated']

router.beforeEach(async (to, from, next) => {
  // 認証情報がない場合データをクリアしてログイン画面に行く
  if (!isAuth() && to.name !== 'login') {
    const ok = await store.dispatch('auth/initAuthInfo')

    if (!ok) {
      store.dispatch('auth/clearLoginInfo')
      return
    }
  }
  // 有効な認証情報を保持している場合ログイン画面には行けない
  if (to.name === 'login') {
    const ok = await store.dispatch('auth/initAuthInfo')
    if (ok) {
      next(from || DEFAULT_ROUTE)
      return
    }
  }
  // 権限の設定により許可されていないページには行けない
  if (store.getters['app/disabledPaths'].includes(to.path.split('/')[1])) {
    next(from)
    return
  }

  next()
})

Vue.use(Meta)

// Bootstrap Analytics
// Set in .env
// https://github.com/MatteoGabriele/vue-analytics
// if (process.env.GOOGLE_ANALYTICS) {
//   Vue.use(VueAnalytics, {
//     id: process.env.GOOGLE_ANALYTICS,
//     router,
//     autoTracking: {
//       page: process.env.NODE_ENV !== 'development'
//     }
//   })
// }

export default router
